// Fires retailer_link_click dataLayer events for all retailer link surfaces:
//   1. .instinct-retailer-links  — product-level metafield-driven list
//   2. .instinct-vendor-buttons  — variant-level vendor logos (Amazon / Chewy / Instacart)
//
// Product data is embedded as data-* attributes on the containing element by Liquid.
// The event schema mirrors the payload in the analytics spec.

(() => {
  const getPageType = () => {
    const name = window.Theme?.template?.name || '';
    if (name.startsWith('product')) return 'pdp';
    if (name.startsWith('collection')) return 'collection';
    return name || 'other';
  };

  document.addEventListener('click', (event) => {
    const link = event.target.closest('[data-retailer-name]');
    if (!link) return;

    const container = link.closest('[data-product-id]');
    if (!container) return;

    const price = parseFloat(container.dataset.productPrice);

    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      event: 'retailer_link_click',
      retailer_name: link.dataset.retailerName,
      retailer_url: link.href,
      product_id: container.dataset.productId,
      product_name: container.dataset.productTitle || undefined,
      product_species: container.dataset.productSpecies || undefined,
      product_price: Number.isFinite(price) ? price : undefined,
      page_type: getPageType(),
    });
  });
})();
